import { useEffect } from "react";

export interface CapturedUtm {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
  referrer?: string;
}

const STORAGE_KEY = "nh_utm";

export function getCapturedUtm(): CapturedUtm {
  if (typeof sessionStorage === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as CapturedUtm;
  } catch {
    return {};
  }
}

export function useUtmCapture() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const params = new URLSearchParams(window.location.search);
    const captured: CapturedUtm = {};

    const map: Array<[keyof CapturedUtm, string]> = [
      ["utmSource", "utm_source"],
      ["utmMedium", "utm_medium"],
      ["utmCampaign", "utm_campaign"],
      ["utmTerm", "utm_term"],
      ["utmContent", "utm_content"],
    ];

    let hasUtm = false;
    for (const [key, param] of map) {
      const v = params.get(param);
      if (v) {
        captured[key] = v;
        hasUtm = true;
      }
    }

    if (document.referrer) {
      captured.referrer = document.referrer;
    }

    // Only overwrite session storage if this load actually carries UTM info
    // (otherwise we'd erase the original entry source on later same-session navigations).
    if (hasUtm || !sessionStorage.getItem(STORAGE_KEY)) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
      } catch {
        // ignore quota / private mode
      }
    }
  }, []);
}
